import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, ChevronDown } from 'lucide-react'

export default function Header() {
  const [isOpen, setIsOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const [showProgramsMenu, setShowProgramsMenu] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    setIsOpen(false)
    setShowProgramsMenu(false)
  }, [location])

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { 
      name: 'Programs', 
      path: '/programs',
      submenu: [
        { name: 'All Programs', path: '/programs' },
        { name: 'Theology', path: '/programs/theology' },
        { name: 'Leadership', path: '/programs/leadership' },
        { name: 'Nursing', path: '/programs/nursing' },
        { name: 'Music Ministry', path: '/programs/music-ministry' },
        { name: 'Construction Management', path: '/programs/construction-management' },
      ]
    },
    { name: 'Admissions', path: '/admissions' },
    { name: 'Contact', path: '/contact' },
  ]

  return (
    <header className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      <nav className="container-custom">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-1">
            <img src="/assets/logos/path106.png" alt="Rudovia Life College Logo" className="h-16 w-auto p-3" />
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              link.submenu ? (
                <div 
                  key={link.name} 
                  className="relative group"
                  onMouseEnter={() => setShowProgramsMenu(true)}
                  onMouseLeave={() => setShowProgramsMenu(false)}
                >
                  <button className="flex items-center space-x-1 text-primary hover:text-secondary transition-colors font-medium">
                    <span>{link.name}</span>
                    <ChevronDown className="w-4 h-4" />
                  </button>
                  <div className={`absolute top-full left-0 mt-0 w-48 bg-white shadow-xl rounded-lg py-2 border border-gray-100 transition-opacity duration-200 ${showProgramsMenu ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
                    {link.submenu.map((sublink) => (
                      <Link
                        key={sublink.path}
                        to={sublink.path}
                        className="block px-4 py-2 text-primary hover:bg-secondary hover:text-white transition-colors"
                      >
                        {sublink.name}
                      </Link>
                    ))}
                  </div>
                </div>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-primary hover:text-secondary transition-colors font-medium ${
                    location.pathname === link.path ? 'text-secondary' : ''
                  }`}
                >
                  {link.name}
                </Link>
              )
            ))}
            <Link to="/admissions" className="btn-primary">
              Apply Now
            </Link>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-primary p-2"
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isOpen && (
          <div className="lg:hidden pb-4">
            {navLinks.map((link) => (
              link.submenu ? (
                <div key={link.name}>
                  <button
                    onClick={() => setShowProgramsMenu(!showProgramsMenu)}
                    className="w-full text-left px-4 py-3 text-primary hover:bg-gray-50 flex items-center justify-between"
                  >
                    <span>{link.name}</span>
                    <ChevronDown className={`w-4 h-4 transition-transform ${showProgramsMenu ? 'rotate-180' : ''}`} />
                  </button>
                  {showProgramsMenu && (
                    <div className="bg-gray-50">
                      {link.submenu.map((sublink) => (
                        <Link
                          key={sublink.path}
                          to={sublink.path}
                          className="block px-8 py-2 text-primary hover:text-secondary"
                        >
                          {sublink.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block px-4 py-3 text-primary hover:bg-gray-50 ${
                    location.pathname === link.path ? 'text-secondary bg-gray-50' : ''
                  }`}
                >
                  {link.name}
                </Link>
              )
            ))}
            <div className="px-4 pt-4">
              <Link to="/admissions" className="btn-primary w-full text-center block">
                Apply Now
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  )
}
